import { render, staticRenderFns } from "./TopFiveBanks.vue?vue&type=template&id=7451ff4f&"
import script from "./TopFiveBanks.vue?vue&type=script&lang=js&"
export * from "./TopFiveBanks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports